import { combineReducers } from 'redux';

import esActiu from './esActiu';
import estacions from './estacions';
import originals from './originals';
import editades from './editades';

export default combineReducers({
    esActiu,
    estacions,
    originals,
    editades
});



// WEBPACK FOOTER //
// ./src/reducers/usuari/formulari/dades/index.js